<template>
    <div ref="recaptcha" class="g-recaptcha"></div>
</template>

<script>
export default {
    data() {
        return {
            widgetId: null,
            sitekey: process.env.VUE_APP_CAPTCHA
        };
    },
    mounted() {
        this.loadRecaptchaScript().then(() => {
            if (window.grecaptcha && !this.widgetId) {
                    window.grecaptcha.ready(() => {
                        this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
                            sitekey: this.sitekey,
                            callback: this.onVerify,
                            'expired-callback': this.expiredCaptcha
                        });
                });
            }
        }).catch((error) => {
            console.error('Failed to load reCAPTCHA script:', error);
        });
    },
    methods: {
        expiredCaptcha(){
            this.$emit('expired');

        },
        onVerify(token) {
            this.$emit('verify', token);
        },
        loadRecaptchaScript() {
            return new Promise((resolve, reject) => {
                if (document.getElementById('recaptcha-script')) {
                    resolve();
                    return;
                    }
                const script = document.createElement('script');
                script.id = 'recaptcha-script';
                script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
                script.async = true;
                script.defer = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        resetRecaptcha() {
            window.grecaptcha.reset(this.widgetId);
        }
    }
};
</script>